/* eslint-disable quotes */
/* eslint-disable array-callback-return */
/* eslint-disable prefer-destructuring */
/* eslint-disable curly */
import React from 'react';
import format from 'date-fns/format';
import _refiner from 'refiner-js';
import { pricingPopupState } from 'Components/common/pricingPopup';
import { confirmationPopupState } from 'Components/common/confirmationPopup';
import NumberFormat from 'react-number-format';
import userDetail from 'Stores/userDetail';
import trialUserOnboardingState from 'Stores/trialUserOnboardingState';
import { URLS, makeApi } from 'Utils/apiUtil';
import { updateMemberOnboardingInfo } from 'Utils/commonApi';
import { trialFormPopupState } from 'Components/common/trialFormPopup';
import { paidUserTechnologyFilterPopupState } from 'Components/common/paidUserTechnologyFilterPopup';
import { toasterState } from 'Components/common/toaster';
import { paygPurchaseMorePopupState } from 'Components/common/paygPurchaseMorePopup';
import { commonUpgradePopupState } from 'Components/common/commonUpgradePopup';
import { loadScriptsDynamically } from '../components/common/loadScriptDynamically';
import * as CONSTANTS from './constants';
import { warningPopupState } from '../components/common/commonWarningPopup';
import { requestQuoteFormPopupState } from '../components/common/requestQuoteFormPopup';
import { commonMsgPopupState } from '../components/common/commonMsgPopup';
import { addToListWithOptionsState } from '../pages/advancedSearch/AddToListWithOptions';

const Utils = {};

Utils.routerProps = {};

Utils.intlProps = null;

const {
  PAGE_PATH_MAP,
  LB_WEB_URL,
  SEOCookieQueryMapping,
  REFINER_EVENTS_AND_PROPERTIES,
  EXPORT_SOURCE,
  UPGRADE_TRIGGERS,
} = CONSTANTS;

Utils.enableBodyScroll = () => {
  if (window && window.document) {
    const ele = window.document.getElementsByTagName('body');
    if (ele[0].classList.contains('stop-scroll'))
      ele[0].classList.remove('stop-scroll');
    else if (ele[0].classList.contains('stop-scroll-x'))
      ele[0].classList.remove('stop-scroll-x');
    else if (ele[0].classList.contains('stop-scroll-y'))
      ele[0].classList.remove('stop-scroll-y');
  }
};

Utils.stopBodyScroll = (hiddenX = false, hiddenY = false) => {
  if (window && window.document)
    if (!hiddenX && !hiddenY) {
      const ele = window.document.getElementsByTagName('body');
      if (!ele[0].classList.contains('stop-scroll'))
        ele[0].classList.add('stop-scroll');
    } else if (hiddenX) {
      const ele = window.document.getElementsByTagName('body');
      if (!ele[0].classList.contains('stop-scroll-x'))
        ele[0].classList.add('stop-scroll-x');
    } else if (hiddenY) {
      const ele = window.document.getElementsByTagName('body');
      if (!ele[0].classList.contains('stop-scroll-y'))
        ele[0].classList.add('stop-scroll-y');
    }
};

Utils.hideSecondryHeader = () => {
  if (window && window.document) {
    const ele = window.document.getElementsByTagName('body');
    if (ele[0].classList.contains('show-sub-head'))
      ele[0].classList.remove('show-sub-head');
  }
};

Utils.showSecondryHeader = () => {
  if (window && window.document) {
    const ele = window.document.getElementsByTagName('body');
    if (!ele[0].classList.contains('show-sub-head'))
      ele[0].classList.add('show-sub-head');
  }
};
Utils.getExportDateString = (dateObj = new Date()) => {
  const dateString = `${`0${dateObj.getMonth() + 1}`.slice(-2) +
    `0${dateObj.getDate()}`.slice(-2) +
    dateObj.getFullYear()}-${`0${dateObj.getHours()}`.slice(
    -2,
  )}${`0${dateObj.getMinutes()}`.slice(-2)}${`0${dateObj.getSeconds()}`.slice(
    -2,
  )}`;

  return dateString;
};

Utils.downloadToCsv = (obj, customPrefix = '') => {
  const fileName =
    customPrefix === ''
      ? `AdaptExport-${Utils.getExportDateString()}`
      : customPrefix;

  const ele = document.createElement('a');
  const href = document.createAttribute('href');
  href.value = `data:attachment/csv;charset=utf-8,${encodeURIComponent(
    obj.csvData,
  )}`;
  ele.setAttributeNode(href);
  const download = document.createAttribute('download');
  download.value = `${fileName}.csv`;
  ele.setAttributeNode(download);
  ele.click();
  ele.remove();
};

// include company domain CSV limit
Utils.getDomainSize = () => {
  const memberId = userDetail.userInfo.memberId;
  if (
    Object.keys(CONSTANTS.customDomainSizeIncludeCompany).includes(memberId)
  ) {
    return CONSTANTS.customDomainSizeIncludeCompany[memberId];
  }
  return CONSTANTS.defaultNameDomainsMaxSize;
};

Utils.getExcludeCompanyDomainSize = () => {
  const memberId = userDetail.userInfo.memberId;
  if (
    Object.keys(CONSTANTS.customDomainSizeExcludeCompany).includes(memberId)
  ) {
    return CONSTANTS.customDomainSizeExcludeCompany[memberId];
  }
  return CONSTANTS.defaultNameDomainsMaxSize;
};

// eslint-disable-next-line consistent-return
Utils.uploadCsv = (
  changeEvent,
  callBack,
  checkMaxEntry,
  checkMaxEntryValue = 25000,
) => {
  const nameDomainsMaxSize = 500;
  const { files } = changeEvent.target;
  if (files.length) {
    const r = new FileReader();
    r.onload = function(e) {
      const contents = e.target.result;
      const domains = contents.split(/\r\n|\n|\r/);

      if (checkMaxEntry !== undefined && checkMaxEntry === true) {
        if (domains.length > checkMaxEntryValue) {
          callBack('error');
        } else {
          const domainMap = {};
          domainMap.fname = files[0].name;
          const validDomain = [];
          // eslint-disable-next-line no-unused-expressions
          domains &&
            domains.map(item => {
              if (item !== '') validDomain.push(item);
            });
          domainMap.entries = validDomain;
          callBack(domainMap);
        }
      } else if (domains.length > nameDomainsMaxSize) {
        callBack('error');
      } else {
        const domainMap = {};
        domainMap.fname = files[0].name;
        let domainNew = [];
        let j = 0;
        for (let i = 0; i < domains.length; i += 1)
          if (domains[i] !== undefined)
            domainNew[(j += 1)] = domains[i].split(',')[0];

        // eslint-disable-next-line consistent-return
        domainNew = domainNew.filter(item => {
          if (item !== '' && item !== undefined) return item;
        });
        domainMap.domains = domainNew;
        callBack(domainMap);
      }
    };

    r.readAsText(files[0]);
  } else {
    callBack(false);
  }
};

Utils.validateDomain = domain => {
  if (
    // eslint-disable-next-line no-useless-escape
    /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/.test(
      domain,
    )
  )
    return true;

  return false;
};

Utils.setLocalStorage = (key, value) => {
  if (key !== undefined && value !== undefined) {
    let val = value;
    if (typeof value === 'object') val = JSON.stringify(val);
    // console.log('set local ', typeof val);
    // console.log('set local ', val);
    localStorage.setItem(key, val);
  }

  // console.log('reads data', JSON.parse(localStorage.getItem(key)));
};

Utils.removeLocalStorage = key => {
  if (key !== undefined) localStorage.removeItem(key);
};

Utils.getLocalStorage = (key, parseVal = true) => {
  let data = {};
  if (localStorage.getItem(key) !== undefined && parseVal)
    data = JSON.parse(localStorage.getItem(key));
  else data = localStorage.getItem(key);
  return data;
};

Utils.numberFormat = (value = '') => {
  return <NumberFormat thousandSeparator displayType="text" value={value} />;
};

Utils.viewsDownloadsNumberFormat = count => {
  if (count >= 10000000) return 'Unlimited';
  return Utils.numberFormat(count);
};

Utils.getCreditResetPeriodInString = (type = 0, creditResetPeriod = 0) => {
  let creditResetPeriodInString = 'per month';
  if (type === 0) creditResetPeriodInString = 'per month';
  else if (creditResetPeriod === 0) creditResetPeriodInString = 'per month';
  else if (creditResetPeriod === 3)
    creditResetPeriodInString = 'every 3 months';
  else if (creditResetPeriod === 6)
    creditResetPeriodInString = 'every 6 months';
  else if (creditResetPeriod === 12) creditResetPeriodInString = 'per year';
  return creditResetPeriodInString;
};

Utils.usNumberFormat = count => {
  let totalNumberForamted = '';

  // eslint-disable-next-line radix
  if (count >= 1000000) totalNumberForamted = `${parseInt(count / 1000000)}M+`;
  else totalNumberForamted = Utils.numberFormat(count);

  return totalNumberForamted;
};

Utils.usNumberFormatForCompanyCount = count => {
  let totalNumberForamted = '';
  // eslint-disable-next-line radix
  if (count >= 1000000) totalNumberForamted = `${parseInt(count / 1000000)}M+`;
  // eslint-disable-next-line radix
  else if (count >= 10000) totalNumberForamted = `${parseInt(count / 1000)}K+`;
  else totalNumberForamted = Utils.numberFormat(count);

  return totalNumberForamted;
};

Utils.registerAppcues = userObj => {
  const { memberId, email } = userObj;
  if (window.Appcues)
    window.Appcues.identify(memberId, {
      email,
    });
};

Utils.registerMixpanel = (pageType = '') => {
  const { userInfo } = userDetail;
  const {
    name,
    email,
    creationTimeStamp = '',
    source,
    mixpanelData = {},
    pageSource,
    lbCredits,
    phoneCreditsRemaining,
    phoneVendorPurchaseEnabled,
  } = userInfo;

  const { referrer = '' } = mixpanelData || {};

  const userType = Utils.isFreemiumPlanActive()
    ? 'Freemium'
    : Utils.isFreeTrialPlan()
    ? 'Trial'
    : Utils.isPaidUser()
    ? 'Paid'
    : 'Free';

  mixpanel.register({
    email,
    name,
    'Signup Date': creationTimeStamp
      ? new Date(creationTimeStamp).toISOString()
      : null,
    'User Source': source,
    'User Referrer': referrer,
    'User Type': userType,
    'Page Source': pageSource,
    isLbCreditsPlan: Utils.isCreditBasedSubscription(),
  });
  mixpanel.identify(email);
  Utils.mixpanelUpdateProfileProperty({
    $email: email,
    $name: name,
    'User Type': userType,
    'Email Credits Remaining': lbCredits,
    'Phone Credits Remaining': phoneCreditsRemaining || 0,
    'Mobile Number Enabled': phoneVendorPurchaseEnabled,
  });
};

Utils.mixpanelAlias = email => {
  mixpanel.alias(email);
  mixpanel.identify(email);
};

Utils.mixpanelTrack = (eventName = '', property = {}) => {
  window.mixpanel.track(eventName, property);
};

Utils.mixpanelUpdateProfileProperty = (property = {}) => {
  window.mixpanel.people.set(property);
};

Utils.mixpanelIncrementProfileProperty = (propertyName = '', value = 1) => {
  if (propertyName) window.mixpanel.people.increment(propertyName, value);
};

Utils.mixpanelReset = () => {
  window.mixpanel.reset();
};

Utils.checkAndRegisterTotango = () => {
  if (!window.totango_options.user) {
    const { userInfo } = userDetail;
    const { email, memberSubscription } = userInfo;
    const totOptions = {
      service_id: CONSTANTS.TOTANGO_SERVICE_ID,
      user: { id: email },
      disable_heartbeat: true,
    };
    if (memberSubscription && memberSubscription.totangoId)
      totOptions.account = { id: memberSubscription.totangoId };
    window.totango_options = totOptions;
    totango.go(window.totango_options);
  }
};

Utils.hubspotEventPush = (event = '', value = '') => {
  const config = {
    url: URLS.hubspotEventPush,
    method: 'POST',
    data: {
      event,
      value,
    },
  };
  makeApi(config);
};

Utils.totangoTrack = (activity = '', moduleValue = '') => {
  if (window.totango && Utils.isPaidSubscription()) {
    Utils.checkAndRegisterTotango();
    window.totango.track(activity, moduleValue, null, null);
  }
};

Utils.showCreditExpiredPopup = (
  type,
  remainingCredits = null,
  isCreditLimitReached = false,
) => {
  Utils.mixpanelTrack(CONSTANTS.MX_AS_EVENTS.AS_PAYWALL_UPGRADE_POPUP, {
    type,
  });
  const callback = () => {
    Utils.upgradeNowClick('paid credit exhausted');
  };

  if (Utils.isCreditBasedSubscription()) {
    if (
      (!Utils.isCreditsWithinMonthlyLimit() ||
        remainingCredits !== null ||
        isCreditLimitReached) &&
      userDetail.userInfo.lbCredits > 0
    ) {
      const message = userDetail.userInfo.isEnterpriseAdmin
        ? 'You have reached a maximum limit of credits allotted for this month.'
        : `You have reached a maximum limit of credits allotted to you. ${
            remainingCredits !== null
              ? ` Please reduce the number of contacts purchased to ${remainingCredits} credits or contact your administrator for more credits`
              : 'Please contact your administrator for more credits.'
          }`;

      warningPopupState.setShowPopup({
        className: `monthly-limit${
          remainingCredits === null ? ' center-message' : ''
        }`,
        title: 'Credit Limit Reached',
        message,
      });
    } else if (userDetail.userInfo.isEnterpriseAdmin) {
      confirmationPopupState.setPopupValues({
        title: `You've run out of credits`,
        content: "Don't miss out on your next big deal!",
        actionBtnText: 'Upgrade Now',
        needCancelBtn: false,
        customClassName: 'credit-expired-popup',
        callback,
      });
      confirmationPopupState.setShowPopup(true);
    } else {
      warningPopupState.setShowPopup({
        className: 'monthly-limit',
        title: 'No Credits Left!',
        message:
          'All the credits are utilized by your team members. Please contact your administrator for more details.',
      });
    }
  } else {
    confirmationPopupState.setPopupValues({
      title: `You've run out of ${type}`,
      content: "Don't miss out on your next big deal!",
      actionBtnText: 'Upgrade Now',
      needCancelBtn: false,
      customClassName: 'credit-expired-popup',
      callback,
    });
    confirmationPopupState.setShowPopup(true);
  }
};

Utils.showEmailConfirmationPopup = emailId => {
  const callback = () => {
    confirmationPopupState.setShowPopup(true);
    const config = {
      url: URLS.resendEmailConfirmation,
      method: 'POST',
      data: {
        email: emailId,
      },
    };
    makeApi(config)
      .then(response => {
        console.log('showEmailConfirmationPopup  ', response);
        if (
          response &&
          response.data !== undefined &&
          response.data === 'true'
        ) {
          const successOkCallback = () => {};
          confirmationPopupState.setPopupValues({
            title: 'Success',
            content:
              'Verification link has been sent! Check your inbox now. Make sure to check your spam/junk folder as well.',
            actionBtnText: 'Ok',
            needCancelBtn: false,
            allowCancelClick: false,
            callback: successOkCallback,
          });
          confirmationPopupState.setShowPopup(true);
        }
      })
      .catch(error => {
        console.log('myLeadsList error ', error);
      });
    // make call
  };
  confirmationPopupState.setPopupValues({
    title: 'Please confirm your account',
    content: `You must confirm your account before purchasing contacts. Please check your inbox at <span>${emailId}</span> for your confirmation email. Make sure to check your spam/junk folder as well.`,
    actionBtnText: 'Resend confirmation',
    customClassName: 'resend-confirmation',
    allowCancelClick: false,
    actionBtnTextCancel: "Can't see it?",
    callback,
  });
  confirmationPopupState.setShowPopup(true);
};

Utils.redirectToPricingPage = (redirect = false) => {
  if (redirect) {
    const { userInfo } = userDetail;
    const { businessEmail = '' } = userInfo;
    let redirectUrl = `${CONSTANTS.WEB_URL}/pricing.htm`;
    if (businessEmail) redirectUrl = `${redirectUrl}?email=${businessEmail}`;
    window.location.href = redirectUrl;
  } else {
    Utils.showUserPricingPopup(true, 'views', false);
  }
};

Utils.redirectToProspectorPricingPage = () => {
  window.location.href = `${CONSTANTS.WEB_URL}/prospector/pricing.htm?ss=true`;
};

Utils.redirectToHomePage = () => {
  // eslint-disable-next-line no-undef
  window.location.href = CONSTANTS.WEB_URL;
};

Utils.redirectToLbHomePage = () => {
  // eslint-disable-next-line no-undef
  window.location.href = LB_WEB_URL;
};

Utils.gotoSalesgearUrl = () => {
  // eslint-disable-next-line no-undef
  window.open(CONSTANTS.SALESGEAR_URL, '_blank');
};

Utils.isBusinessEmail = () => {
  const { businessEmail = null } = userDetail.userInfo;
  return businessEmail;
};

Utils.addBusinessEmailToUrl = () => {
  const { businessEmail } = userDetail.userInfo;
  const { location, history = null } = Utils.routerProps || {};
  const { pathname = '' } = location;
  const hash = window.location.hash;
  if (history && businessEmail)
    history.push(`${pathname}?email=${businessEmail}${hash}`);
};

Utils.removeBusinessEmailFromUrl = () => {
  const { location, history = null } = Utils.routerProps || {};
  const { pathname = '' } = location;
  const hash = window.location.hash;
  if (history) history.push(`${pathname}${hash}`);
};

Utils.checkCurrentUrl = (url = '') => {
  const { location } = Utils.routerProps || {};
  const { pathname = '' } = location || {};
  if (pathname === url) return true;
  return false;
};

Utils.redirectToUrl = (pathname = null) => {
  if (pathname !== null) {
    const { history = null } = Utils.routerProps || {};
    if (history) history.push(pathname);
  }
};

Utils.redirectToLBPricingPage = () => {
  const { history = null } = Utils.routerProps || {};
  if (history) history.push('/pricing');
};

Utils.upgradeNowClick = source => {
  Utils.mixpanelTrack(CONSTANTS.MX_COMMON_EVENTS.LB_UPGRADE_CLICK, {
    Source: source,
  });
  Utils.redirectToLBPricingPage();
};

Utils.isFreemiumPlanActive = () => {
  const { userInfo } = userDetail;
  const { memberSubscription } = userInfo;
  const { subscriptionCategory = 0 } = memberSubscription || {};
  return subscriptionCategory === 1;
};

Utils.isPaidUser = () => {
  const { type } = userDetail.userInfo;

  if (type && type === 1) return true;

  return false;
};

Utils.isPaidSubscription = () => {
  const { isFreeTrial } = userDetail;
  return Utils.isPaidUser() ? !isFreeTrial : false;
};

Utils.isFreeTrialPlan = () => {
  const { isFreeTrial } = userDetail;
  return isFreeTrial;
};

Utils.isEnterpriseFreeTrialPlan = () => {
  const { isFreeTrial, isEnterpriseFreeTrial } = userDetail;
  return isFreeTrial && isEnterpriseFreeTrial;
};

Utils.isLBPaidUser = () => {
  const { type } = userDetail.userInfo;
  const { LEAD_BUILDER = false } = userDetail.featureFlags;

  if (type && type === 1 && LEAD_BUILDER && !Utils.isFreemiumPlanActive())
    return true;

  return false;
};

Utils.isLBPaidSubscription = () => {
  const { isFreeTrial, userInfo, featureFlags } = userDetail;
  const { type } = userInfo;
  const { LEAD_BUILDER = false } = featureFlags;

  if (
    type &&
    type === 1 &&
    LEAD_BUILDER &&
    !isFreeTrial &&
    !Utils.isFreemiumPlanActive()
  )
    return true;

  return false;
};

Utils.isSuppressionListEnabled = () => {
  const { type } = userDetail.userInfo;
  const { SUPPRESSION_LIST = false } = userDetail.featureFlags;

  if (type && type === 1 && SUPPRESSION_LIST) return true;

  return false;
};

Utils.isTrialUsed = () => {
  const { trialUsed } = userDetail.userInfo;

  if (trialUsed) return true;

  return false;
};

Utils.isConciergeEnabled = () => {
  const { CONCIERGE = false } = userDetail.featureFlags;

  if (CONCIERGE) return true;

  return false;
};

Utils.isInsideStoryEnabled = () => {
  const { INSIDE_STORY = false } = userDetail.featureFlags;

  if (INSIDE_STORY) return true;

  return false;
};

Utils.isSavedSearchUpdateEnabled = () => {
  return Utils.isLBPaidSubscription();
  // const { SAVED_SEARCH_UPDATES = false } = userDetail.featureFlags;
  // if (SAVED_SEARCH_UPDATES) return true;
  // return false;
};

Utils.isPaymentPendingReview = () => {
  const { paymentPending } = userDetail.userInfo;

  if (paymentPending !== null) return true;

  return false;
};

Utils.showFreeTrialPopup = (
  showPopup = false,
  type,
  unlock = false,
  isHubspotForm = false,
) => {
  Utils.addBusinessEmailToUrl();
  Utils.mixpanelTrack(CONSTANTS.MX_HEADER_EVENT.START_FREE_TRIAL, {});
  pricingPopupState.setShowPricingPopup(showPopup, type, unlock, isHubspotForm);
};

Utils.showUserPricingPopup = (show = true, type, unlock) => {
  const { isFreeTrial, userInfo, featureFlags } = userDetail;
  const { userStatus, email, trialUsed } = userInfo;
  const { LEAD_BUILDER = false } = featureFlags;
  if (userStatus === 0) {
    Utils.redirectToLBPricingPage();
  } else {
    Utils.showEmailConfirmationPopup(email);
  }
};

Utils.handleTrialUpgradeNow = (fromPosition = 'header') => {
  Utils.addBusinessEmailToUrl();
  trialUserOnboardingState.upgradeNow();
  trialFormPopupState.setShowTrialUpgradeForm(true);
};

Utils.handleTalkToSalesForTeckFilter = (fromPosition = 'header') => {
  Utils.addBusinessEmailToUrl();
  requestQuoteFormPopupState.setShowRequestQuoteForm(true);
};

Utils.generateRandomPayload = () => {
  const number1 = Math.floor(Math.random() * 10 + 1);
  const number2 = Math.floor(Math.random() * 10 + 1);
  const newObj = { n1: number1, n2: number2, n3: number1 + number2 };
  return newObj;
};

Utils.getQueryParamFromUrl = (params, url) => {
  const href = url;
  const reg = new RegExp(`[?&]${params}=([^&#]*)`, 'i');
  const queryString = reg.exec(href);
  return queryString ? queryString[1] : null;
};

Utils.copyToClipBoard = str => {
  const el = document.createElement('textarea');
  el.value = str;
  el.setAttribute('readonly', '');
  el.style.position = 'absolute';
  el.style.left = '-9999px';
  document.body.appendChild(el);
  el.select();
  document.execCommand('copy');
  document.body.removeChild(el);
};

Utils.addDays = function(currentDate, days) {
  // eslint-disable-next-line radix
  currentDate.setDate(currentDate.getDate() + parseInt(days));
  return currentDate;
};

Utils.validateEmailFormat = email => {
  // eslint-disable-next-line no-useless-escape
  const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
};

Utils.getTrialExpiryDate = function(noofdays) {
  const currentDate = new Date();
  let trialExpiryDate;
  if (noofdays === undefined) trialExpiryDate = this.addDays(currentDate, 7);
  else trialExpiryDate = this.addDays(currentDate, noofdays);

  const day = trialExpiryDate.getDate();
  const monthIndex = trialExpiryDate.getMonth();
  const year = trialExpiryDate.getFullYear();
  return `${CONSTANTS.monthNames[monthIndex]} ${day}, ${year}`;
};

Utils.getCookie = name => {
  const nameEQ = `${name}=`;
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i += 1) {
    let c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
};

Utils.setCookie = (cname, cvalue, exdays, exHours = 24) => {
  const d = new Date();
  console.log('cutrent date  ', d);
  d.setTime(
    d.getTime() + exdays * 24 * 60 * 60 * 1000 + exHours * 60 * 60 * 1000,
  );
  console.log(' Expiry Date   ', d);

  const expires = `expires=${d.toUTCString()}`;
  let domain = window.location.host;
  if (domain.includes('localhost:3000')) domain = 'localhost';
  else domain = Utils.getDomainName();

  const curDomain = `domain=${domain};`;
  document.cookie = `${cname}=${cvalue};${curDomain}${expires};path=/`;
};

Utils.getDomainName = (url = window.location.host) => {
  const parts = url.split('.');
  if (parts.length > 2) return `${parts[1]}.${parts[2]}`;

  return '';
};

Utils.deleteCookie = name => {
  let domain = window.location.host;
  if (domain.includes('localhost:3000')) domain = 'localhost';
  else domain = Utils.getDomainName();

  const curDomain = `domain=${domain};`;
  document.cookie = `${name}=;${curDomain}expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/;`;
};

Utils.getIndustryKeywordArray = (data = []) => {
  const industryKeywordArray = [];
  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < data.length; i++)
    if (data[i].sectors === null || data[i].sectors.length <= 0) {
      const industryKW = data[i].industries;
      // eslint-disable-next-line no-plusplus
      for (let j = 0; j < industryKW.length; j++)
        if (industryKeywordArray.indexOf(industryKW[j]) === -1)
          industryKeywordArray.push(industryKW[j]);
    }

  return industryKeywordArray;
};

Utils.getSectorKeywordArray = (data = []) => {
  const sectorKeywordArray = [];
  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < data.length; i++)
    if (data[i].sectors !== null && data[i].sectors.length > 0) {
      const sectorKW = data[i].sectors;
      // eslint-disable-next-line no-plusplus
      for (let j = 0; j < sectorKW.length; j++)
        if (sectorKeywordArray.indexOf(sectorKW[j]) === -1)
          sectorKeywordArray.push(sectorKW[j]);
    }

  return sectorKeywordArray;
};

Utils.extractValuesFromObject = item => {
  return Object.values(item).map(values => values);
};

Utils.copyObjectWithoutReference = (obj = {}) => {
  return JSON.parse(JSON.stringify(obj));
};

// eslint-disable-next-line consistent-return
Utils.isSalesgearExportEnabled = () => {
  return userDetail?.featureFlags?.LB_ENGAGE_EXPORT_ENABLED;
};

// eslint-disable-next-line consistent-return
Utils.checkAndInsertAt = (array = [], index, newElem) => {
  if (array.length && index && newElem) {
    if (!array.includes(newElem)) array.splice(index, 0, newElem);
    return array;
  }
  return array;
};

Utils.numberformatWithText = (
  number,
  text = '',
  addBoldTag = false,
  isAddZero = null,
) => {
  let forStr = '';
  if (number !== undefined && number !== null) {
    if (isAddZero !== null) forStr = isAddZero + number;
    else forStr = number;
    if (addBoldTag) forStr = `<b>${forStr}</b>`;

    forStr += text + (number > 1 && text !== '' ? 's' : '');
  }

  return forStr;
};

Utils.validateStringLength = (value, len) => {
  const str = value.trim();
  if (
    str &&
    str !== undefined &&
    str !== '' &&
    str.length > 0 &&
    str.length >= len
  )
    return true;

  return false;
};

Utils.isValidPhone = phone => {
  const numberPattern = /[0-9]/g;
  const matchNo = phone.match(numberPattern);
  if (matchNo) return phone.match(numberPattern).length > 6;

  return false;
};

Utils.initiateIntl = (initiate, selector = '') => {
  setTimeout(function() {
    const input = document.querySelector(selector);
    if ((input !== null && Utils.intlProps === null) || initiate) {
      // initialise plugin
      window.iti = window.intlTelInput(input, {
        initialCountry: 'us',
        placeholderNumberType: 'MOBILE',
        utilsScript:
          'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/15.0.2/js/utils.js',
      });
      Utils.intlProps = window.iti;
    }
  }, 300);
};

Utils.formatNumberToDecimalPoints = (number = 1, places = 2) => {
  return (Math.round(number * 100) / 100).toFixed(places);
};

Utils.getLockFilterBtnText = () => {
  // let lockBtnText = 'Start Free Trial';
  // const { LEAD_BUILDER = false } = userDetail.featureFlags;

  // if (Utils.isPaidUser() && !LEAD_BUILDER) lockBtnText = 'Upgrade now';
  // else if (!LEAD_BUILDER && !Utils.isPaidUser() && Utils.isTrialUsed())
  //   lockBtnText = 'Upgrade now';

  return 'Upgrade now';
};

Utils.checkValueInObject = (obj = null, key = null, value) => {
  if (obj !== null && key !== null && obj[key] === value) return true;

  return false;
};

Utils.isCreditBasedSubscription = () => {
  const { userInfo } = userDetail;
  const { lbCreditsPlan = false } = userInfo;
  return lbCreditsPlan;
};

Utils.checkAndShowFreeTrialOneTimePopup = () => {
  // const { trialUsed, userStatus, memberOnboardingInfo } = userDetail.userInfo;
  const { userStatus, memberOnboardingInfo } = userDetail.userInfo;
  const { LEAD_BUILDER = false } = userDetail.featureFlags;
  if (
    userStatus === 0 &&
    // !trialUsed &&
    !Utils.isPaidUser() &&
    !LEAD_BUILDER &&
    (memberOnboardingInfo === null ||
      !Utils.checkValueInObject(
        memberOnboardingInfo,
        CONSTANTS.MEMBER_ONBOARDING_INFO.FREE_TRIAL_ONE_TIME_POPUP,
        true,
      ))
  ) {
    const data = {};
    data[CONSTANTS.MEMBER_ONBOARDING_INFO.FREE_TRIAL_ONE_TIME_POPUP] = true;
    updateMemberOnboardingInfo(data);
    Utils.mixpanelTrack(
      CONSTANTS.MX_HEADER_EVENT.START_FREE_TRIAL_FIRST_TIME,
      {},
    );
    Utils.showUserPricingPopup(true);
  }
};

Utils.checkAndShowPaidUserTechnologyFilterOneTimePopup = () => {
  const { userInfo, featureFlags, isFreeTrial } = userDetail;
  const { userStatus, memberOnboardingInfo } = userInfo;
  const { TECHNOLOGY_FILTER = false } = featureFlags;

  if (
    userStatus === 0 &&
    Utils.isPaidUser() &&
    !isFreeTrial &&
    !TECHNOLOGY_FILTER &&
    (memberOnboardingInfo === null ||
      !Utils.checkValueInObject(
        memberOnboardingInfo,
        CONSTANTS.MEMBER_ONBOARDING_INFO
          .PAID_USER_TECHNOLOGY_FILTER_ONE_TIME_POPUP,
        true,
      ))
  ) {
    const data = {};
    data[
      CONSTANTS.MEMBER_ONBOARDING_INFO.PAID_USER_TECHNOLOGY_FILTER_ONE_TIME_POPUP
    ] = true;
    updateMemberOnboardingInfo(data);
    Utils.mixpanelTrack(
      CONSTANTS.MX_AS_EVENTS.LB_AS_TECHNOLOGY_FILTER_POPUP_VIEW,
      { actionEvent: 'oneTimePopupFlow' },
    );
    paidUserTechnologyFilterPopupState.setShowPopup(true);
  }
};

Utils.generateCustomS3Scriptpath = path => {
  if (path) {
    const newPath = CONSTANTS.S3_BASE_PATH + CONSTANTS.S3_BUCKET_PATH + path;
    return newPath;
  }
  return '';
};

Utils.isProductionEnv = () => {
  if (process.env.BUILD_ENV && process.env.BUILD_ENV === 'production')
    return true;

  return false;
};

Utils.isStagingEnv = () => {
  if (process.env.BUILD_ENV && process.env.BUILD_ENV === 'staging') return true;

  return false;
};

Utils.isLocalEnv = () => {
  if (process.env.BUILD_ENV && process.env.BUILD_ENV === 'local') return true;

  return false;
};

Utils.addSessionRecordingForTrialUser = () => {
  const { isFreeTrial, userInfo } = userDetail;
  const { email } = userInfo;
  if (isFreeTrial && Utils.isProductionEnv()) {
    const script = document.createElement('script');
    script.src = Utils.generateCustomS3Scriptpath(
      CONSTANTS.EXTERNAL_S3_SCRIPTS.INSPECTLET_SESSION_RECORDING,
    );
    script.async = true;
    document.body.appendChild(script);

    const intervalObj = setInterval(() => {
      // eslint-disable-next-line no-underscore-dangle
      if (window.__insp) {
        clearInterval(intervalObj);
        // eslint-disable-next-line no-underscore-dangle
        window.__insp.push(['identify', email]);
        // eslint-disable-next-line no-underscore-dangle
        window.__insp.push(['tagSession', { email }]);
      }
    }, 100);
  }
};

Utils.addSessionRecordingForLbPaidUser = () => {
  const { userInfo } = userDetail;
  const { LEAD_BUILDER = false } = userDetail.featureFlags;
  const { email } = userInfo;
  if (LEAD_BUILDER && Utils.isProductionEnv()) {
    const script = document.createElement('script');
    script.src = Utils.generateCustomS3Scriptpath(
      CONSTANTS.EXTERNAL_S3_SCRIPTS.INSPECTLET_SESSION_RECORDING,
    );
    script.async = true;
    document.body.appendChild(script);

    const intervalObj = setInterval(() => {
      // eslint-disable-next-line no-underscore-dangle
      if (window.__insp) {
        clearInterval(intervalObj);
        // eslint-disable-next-line no-underscore-dangle
        window.__insp.push(['identify', email]);
        // eslint-disable-next-line no-underscore-dangle
        window.__insp.push(['tagSession', { email }]);
      }
    }, 100);
  }
};

Utils.addSessionRecordingForPricingRedirectionFlow = () => {
  const { userInfo } = userDetail;
  const { email } = userInfo;
  if (Utils.isProductionEnv()) {
    const script = document.createElement('script');
    script.src = Utils.generateCustomS3Scriptpath(
      CONSTANTS.EXTERNAL_S3_SCRIPTS.INSPECTLET_SESSION_RECORDING,
    );
    script.async = true;
    document.body.appendChild(script);

    const intervalObj = setInterval(() => {
      // eslint-disable-next-line no-underscore-dangle
      if (window.__insp) {
        clearInterval(intervalObj);
        // eslint-disable-next-line no-underscore-dangle
        window.__insp.push(['identify', email]);
        // eslint-disable-next-line no-underscore-dangle
        window.__insp.push(['tagSession', { email }]);
      }
    }, 100);
  }
};

Utils.checkEmailDomain = (email, domain) => {
  const emailAddress = email.toLowerCase();
  if (emailAddress && domain) {
    const newDomain = emailAddress.split('@').pop();
    if (newDomain && newDomain.indexOf(domain) >= 0) {
      return false;
    }
  }
  return true;
};

Utils.checkIsPartialHeaderLayout = props => {
  const { location } = props || {};
  const { pathname = '' } = location || {};
  const partialHeaderUrls = [
    '/advanced-search/contact',
    '/advanced-search/company',
    '/my-leads',
    '/seeker',
    '/inside-story',
    '/inside-enki-story',
  ];
  const matchingUrls = partialHeaderUrls.filter(item =>
    pathname.includes(item),
  );
  return matchingUrls.length > 0;
};

Utils.checkAndShowNewFeature = props => {
  const { location, showNotificationBar = '' } = props || {};
  const { pathname = '' } = location || {};

  const { SUPPRESSION_LIST } = CONSTANTS.NOTIFICATION_BAR_TYPE.NEW_FEATURE;

  if (
    SUPPRESSION_LIST === showNotificationBar &&
    pathname === '/suppression-list'
  )
    return false;
  return true;
};

Utils.upperCaseFirstCharacter = (str = '') => {
  let newStr = str;
  if (str !== '')
    newStr = str.substring(0, 1).toUpperCase() + str.substring(1, str.length);

  return newStr;
};

Utils.generateUrl = (url, data = {}) => {
  if (url) {
    let newUrl = '';
    const splitUrl = url.split('?');
    if (splitUrl[0]) {
      newUrl += splitUrl[0];
      const dynamicParams = newUrl.match(/(<<[^<>]*>>)/g);
      if (dynamicParams && dynamicParams.length > 0) {
        dynamicParams.forEach((item, index) => {
          newUrl = newUrl.replace(item, data[item.replace(/[<>]/g, '')]);
        });
      }
    }

    if (splitUrl[1]) {
      newUrl += '?';
      const paramSplit = splitUrl[1].split('&');
      paramSplit.map((item, index) => {
        if (item.includes('::')) {
          const splitParamKey = item.split('=')[0];
          if (data[splitParamKey] !== undefined) {
            if (index > 0) newUrl += '&';
            newUrl = `${newUrl + splitParamKey}=${data[splitParamKey]}`;
          }
        } else {
          if (index > 0) newUrl += '&';
          newUrl += item;
        }
      });
    }

    return newUrl;
  }
  return '';
};

Utils.refreshPage = () => {
  window.location.reload();
};

Utils.loadRegistrationTrackingCode = () => {
  const { THIRD_PARTY_SCRIPTS } = CONSTANTS;
  const { REGISTRATION_TRACKING } = THIRD_PARTY_SCRIPTS;
  const { ID, SCRIPT_URL } = REGISTRATION_TRACKING;
  loadScriptsDynamically(
    ID,
    SCRIPT_URL,
    () => {
      console.log('registration tracking loaded');
    },
    'img',
  );
};

// super admin/ Adapt internal employee admins
Utils.isInternalAdminUser = () => {
  const { userInfo } = userDetail;
  const { role = 'ROLE_MEMBER' } = userInfo;
  if (role === 'ROLE_ADMIN') return true;
  return false;
};

Utils.getUserType = () => {
  const { isFreeTrial } = userDetail;

  const userType = Utils.isPaidUser()
    ? isFreeTrial
      ? 'TRIAL'
      : 'PAID'
    : 'FREE';

  return userType;
};

Utils.getPlanType = () => {
  const { userInfo, isFreeTrial } = userDetail;
  const { memberSubscription } = userInfo;

  const planType =
    memberSubscription && !isFreeTrial
      ? memberSubscription.type === 0
        ? 'Monthly'
        : 'Yearly'
      : '';

  return planType;
};

Utils.getSecondaryHsEmail = () => {
  const { secondaryEmail = '', secondaryHsEmail = '' } = userDetail.userInfo;

  return secondaryEmail || secondaryHsEmail;
};

Utils.getPlanAmount = () => {
  const { userInfo } = userDetail;
  const { memberSubscription } = userInfo;

  const planAmount = memberSubscription ? memberSubscription.price : 0;

  return planAmount;
};

Utils.sendAttributeToHotjar = () => {
  if (window.hj) {
    const { memberId, email } = userDetail.userInfo;

    const userType = Utils.getUserType();
    const secondaryHsEmail = Utils.getSecondaryHsEmail();
    const planAmount = Utils.getPlanAmount();
    const planType = Utils.getPlanType();

    window.hj('identify', memberId, {
      email,
      userType,
      secondaryEmail: secondaryHsEmail,
      planAmount,
      planType,
    });
  }
};

Utils.checkIsEmailVerified = (showPopup = true) => {
  const { userInfo } = userDetail;
  const { userStatus, email } = userInfo;
  if (userStatus !== 0) {
    if (showPopup) Utils.showEmailConfirmationPopup(email);
    return false;
  }
  return true;
};

Utils.checkIsSecondaryEmailVerified = () => {
  const { userInfo } = userDetail;
  const { secondaryEmail, secondaryEmailStatus } = userInfo;
  if (secondaryEmail && secondaryEmailStatus !== 0) {
    return false;
  }
  return true;
};

Utils.getUserEmail = () => {
  const { userInfo } = userDetail;
  const { email } = userInfo;

  return email;
};

Utils.getUserSecondaryEmail = () => {
  const { userInfo } = userDetail;
  const { secondaryEmail = '' } = userInfo;

  return secondaryEmail;
};

Utils.isMobileWaterFallEnabled = () => {
  const { userInfo } = userDetail;
  const { memberSubscription = null } = userInfo;

  if (memberSubscription) {
    const { mobileWaterfallEnabled } = memberSubscription;
    return mobileWaterfallEnabled;
  }
  return false;
};

Utils.getSuppressionListEmailLimit = () => {
  const { userInfo } = userDetail;
  const { suppressionListEmailLimit } = userInfo;
  if (suppressionListEmailLimit) return suppressionListEmailLimit;
  return 25000;
};

Utils.checkIfDateIsBiggerThanCompareDate = (date, compareDate = new Date()) => {
  if (compareDate.getTime() > date.getTime()) return true;
  return false;
};

Utils.isNotUndefinedNotNull = value => {
  if (value !== undefined && value !== null) {
    return true;
  }
  return false;
};

Utils.isZeroBounceEnabled = () => {
  const { memberSubscription } = userDetail.userInfo;
  const { realtimeEmailValidationEnabled = false } = memberSubscription || {};

  return realtimeEmailValidationEnabled;
};

Utils.showActivateAccountFlow = () => {
  Utils.redirectToUrl('/activate-account');
  userDetail.setShowActivateAccountPage(true);
};

Utils.checkAndShowAccountActivationToast = () => {
  setTimeout(() => {
    if (Utils.getCookie('account_verification_flow') === 'true') {
      toasterState.setToastMsg(
        'Welcome aboard! Your account activation is successful.',
        'success',
        { timeout: 5000 },
      );
      Utils.deleteCookie('account_verification_flow');
    }
  }, 200);
};

Utils.checkAndShowTrialActivationToast = () => {
  setTimeout(() => {
    if (Utils.getCookie('trial_activate_success') === 'true') {
      toasterState.setToastMsg('Your trial is now activated.', 'success', {
        timeout: 5000,
      });
      Utils.deleteCookie('trial_activate_success');
    }
  }, 200);
};

Utils.isCrmEnrichmentEnabled = () => {
  const { userInfo } = userDetail;
  const { memberSubscription = null } = userInfo;

  if (memberSubscription) {
    const { crmEnrichmentEnabled } = memberSubscription;
    return crmEnrichmentEnabled;
  }
  return false;
};

Utils.getCustomPagePath = path => {
  if (path) return `${window.location.origin}${PAGE_PATH_MAP[path]}`;
  return '';
};

Utils.checkAndShowG2Popup = () => {
  const { userInfo, isFreeTrial } = userDetail;
  const { memberSubscription, lbCredits } = userInfo;

  if (isFreeTrial) {
    const { lbCredits: allocatedCredits } = memberSubscription;
    if (
      // eslint-disable-next-line radix
      parseInt(allocatedCredits * 0.75) > lbCredits &&
      localStorage.getItem('g2') === null
    ) {
      userDetail.setShowG2Popup(true);
      Utils.setLocalStorage('g2', {
        lastShown: Number(new Date()),
        count: 1,
        reviewed: false,
      });
      Utils.mixpanelTrack(CONSTANTS.G2_EVENTS.G2_POPUP_SHOWN, {});
    } else if (localStorage.getItem('g2') !== null) {
      const previousData = Utils.getLocalStorage('g2');
      const { lastShown, count, reviewed = false } = previousData;
      const currentDate = Number(new Date());
      if ((currentDate - lastShown) / 3.6e6 > 8 && count < 3 && !reviewed) {
        userDetail.setShowG2Popup(true);
        Utils.mixpanelTrack(CONSTANTS.G2_EVENTS.G2_POPUP_SHOWN, {});
        Utils.setLocalStorage('g2', {
          lastShown: currentDate,
          count: count + 1,
          reviewed,
        });
      }
    }
  }
};

Utils.checkIsDashboardAllowed = () => {
  const { userInfo } = userDetail;
  const { memberSubscription = null } = userInfo;
  if (memberSubscription !== null) {
    const { id } = memberSubscription;
    if (CONSTANTS.DASHBOARD_ALLOWED_SUBSCRIPTION_IDS.includes(id)) return true;
  }
  return false;
};

Utils.checkFieldMappingTypeSupport = (adaptType, crmType) => {
  const { ENUM, STRING } = CONSTANTS.CRM_FIELD_TYPES;
  if (adaptType === crmType || (adaptType === ENUM && crmType === STRING))
    return true;

  return false;
};

Utils.getProspectorUserTrigger = url => {
  return Utils.getQueryParamFromUrl('trigger', url);
};

Utils.addQueryParamToUrl = (key, value) => {
  const { history = null } = Utils.routerProps || {};
  const url = new URL(window.location.href);
  const searchParams = url.searchParams;
  searchParams.set(key, value);
  url.search = searchParams.toString();

  const newUrl = decodeURIComponent(url.toString());
  const { pathname = '', search = '', hash = '' } = new URL(newUrl);

  if (history && key) history.push(`${pathname}${search}${hash}`);
};

Utils.removeQueryParamToUrl = key => {
  const { history = null } = Utils.routerProps || {};
  const url = new URL(window.location.href);
  const searchParams = url.searchParams;
  searchParams.delete(key);
  url.search = searchParams.toString();

  const newUrl = decodeURIComponent(url.toString());
  const { pathname = '', search = '', hash = '' } = new URL(newUrl);

  if (history && key) history.push(`${pathname}${search}${hash}`);
};

Utils.isCreditsWithinMonthlyLimit = () => {
  const {
    remainingIndividualLbCredits,
    creditLimitEnabled,
  } = userDetail.userInfo;
  if (
    remainingIndividualLbCredits === -1 ||
    remainingIndividualLbCredits === null ||
    remainingIndividualLbCredits === undefined ||
    !creditLimitEnabled
  )
    return true;
  return remainingIndividualLbCredits > 0;
};

Utils.isPaygPlan = () => {
  const { userInfo } = userDetail;
  const { memberSubscription } = userInfo;
  if (memberSubscription !== null) {
    const { planVersion = '' } = memberSubscription;
    if (planVersion === 'LB_CREDITS_PAYG_PLAN') return true;
  }
  return false;
};

Utils.openManageBillingPage = () => {
  window.open(Utils.getCustomPagePath('BILLING'), '_blank');
};

Utils.redirectToManageBillingPage = () => {
  const { history = null } = Utils.routerProps || {};
  if (history) history.push(PAGE_PATH_MAP.BILLING);
};

Utils.redirectToBuyMoreCreditsPage = () => {
  const { history = null } = Utils.routerProps || {};
  if (history) history.push(PAGE_PATH_MAP.BUY_MORE_CREDITS);
};

Utils.checkUserHasEnoughCredits = async (
  selectedCount = 1,
  actionSource = '',
  callback = () => {},
  creditsType = 'email',
) => {
  // For the phase one this check implemented for new PAYG customer
  if (Utils.isPaygPlan() || Utils.isFreeTrialPlan()) {
    paygPurchaseMorePopupState.setPaygCheckLoader(true);
    const config = {
      url: URLS.fetchCredits,
    };
    let remainingCredits = userDetail.userInfo.lbCredits;
    let remainingPhoneCredits = userDetail.userInfo.phoneCreditsRemaining;

    const response = await makeApi(config);
    if (response?.data) {
      const {
        status,
        teamCreditsRemaining,
        teamPhoneCreditsRemaining,
        asyncPending = 0,
        asyncPhonePending = 0,
      } = response.data;
      if (status === 'success') {
        remainingCredits = teamCreditsRemaining - asyncPending;
        remainingPhoneCredits = teamPhoneCreditsRemaining - asyncPhonePending;
      }
    }

    const availableEmailCredits = remainingCredits;
    const availablePhoneCredits = remainingPhoneCredits;

    const isEnoughCreditsNotAvailable =
      creditsType === 'email'
        ? selectedCount > availableEmailCredits
        : creditsType === 'phone'
        ? selectedCount > availablePhoneCredits
        : creditsType === 'all'
        ? selectedCount > availablePhoneCredits ||
          selectedCount > availableEmailCredits
        : false;

    if (isEnoughCreditsNotAvailable) {
      if (Utils.isFreeTrialPlan() || Utils.isFreemiumPlanActive()) {
        paygPurchaseMorePopupState.setPaygCheckLoader(false);
        commonUpgradePopupState.setShowUpgradePopup(
          UPGRADE_TRIGGERS.VIEW_CONTACT_NO_CREDIT,
        );
      } else {
        // TODO log the request count and remaining details

        callback({
          lessCredits: true,
          availableEmailCredits,
          availablePhoneCredits,
        });
        paygPurchaseMorePopupState.setPaygCheckLoader(false);

        // Will be implemented later
        // let additionalCreditsRequired = selectedCount - availableCredits;
        // let isMinimumPurchase = false;
        // if (additionalCreditsRequired < 300) {
        //   additionalCreditsRequired = 300;
        //   isMinimumPurchase = true;
        // }

        // const url = Utils.generateUrl(URLS?.getPriceAmount, {
        //   credits: additionalCreditsRequired,
        // });
        // const pricingConfig = {
        //   url,
        // };
        // const priceResponse = await makeApi(pricingConfig);
        // let amount = 0;

        // if (priceResponse?.data) amount = priceResponse.data;

        // Utils.mixpanelTrack(
        //   CONSTANTS.MX_PAYG_PRICING_EVENT.LB_PAYG_PURCHASE_FLOW_BUY_MORE_POPUP,
        //   {
        //     'Action Source': actionSource,
        //     'Credits Threshold': isMinimumPurchase ? 'Minimum ' : 'Above',
        //     'Credits Remaining': remainingCredits,
        //     'Credits Requested': selectedCount,
        //     'Additional Credits': additionalCreditsRequired,
        //     Amount: amount,
        //   },
        // );
        // paygPurchaseMorePopupState.setPaygCheckLoader(false);

        // paygPurchaseMorePopupState.setPopupValues({
        //   numberOfCreditsRequired: additionalCreditsRequired,
        //   amount,
        //   isMinimumPurchase,
        //   callback,
        // });
        // const { CURRENT_STEPS } = paygPurchaseMorePopupState;
        // paygPurchaseMorePopupState.setShowPopup(
        //   CURRENT_STEPS.REQUIRED_CREDITS_SCREEN,
        // );
      }
    } else {
      paygPurchaseMorePopupState.setPaygCheckLoader(false);
      callback();
    }
  } else {
    callback();
  }
};

Utils.isProspectorRegisteredUser = () => {
  const { USER_SOURCE } = CONSTANTS;
  const { ADAPT_PROSPECTOR } = USER_SOURCE;
  const { userInfo } = userDetail;
  const { source } = userInfo;

  if (source === ADAPT_PROSPECTOR) return true;
  return false;
};

Utils.checkPasswordSetupFlow = () => {
  const { userInfo } = userDetail;
  const { isSetPassword } = userInfo;
  if (Utils.checkIsEmailVerified(false) && isSetPassword) return true;
  return false;
};

Utils.showPasswordSetupFlow = () => {
  Utils.redirectToUrl('/password-setup');
};

Utils.checkAndRedirectTrialUser = () => {
  const landingURL = Utils.getCookie(SEOCookieQueryMapping.landingURL);
  if (landingURL !== null) {
    Utils.deleteCookie(SEOCookieQueryMapping.landingURL);
    if (PAGE_PATH_MAP.CONTACT_SEARCH.includes(landingURL))
      window.location.href = `${LB_WEB_URL}${PAGE_PATH_MAP.CONTACT_SEARCH}`;
    else window.location.href = `${LB_WEB_URL}${landingURL}`;
  } else {
    window.location.href = `${LB_WEB_URL}${PAGE_PATH_MAP.CONTACT_SEARCH}`;
  }
};

Utils.enterprisePlanInterestNotification = (
  notificationType = '',
  callback,
) => {
  const url = Utils.generateUrl(URLS?.notifyEnterprisePlanInterest, {
    notificationType,
  });
  const config = {
    url,
  };

  makeApi(config)
    .then(response => {
      callback();
      const status = response && response.data;
      Utils.showFeedbackPopup(status);
    })
    .catch(error => {
      callback();
      Utils.showFeedbackPopup(false);
      console.log('notifyEnterprisePlanInterest error ', error);
    });
};

Utils.showFeedbackPopup = (success, email = 'support@adapt.io') => {
  const description = (
    <>
      A Growth Expert from Adapt will reach out to you shortly. If you have any
      prior questions, please write to us at{' '}
      <a href={`mailto:${email}`}>{email}</a>
    </>
  );

  const descriptionError = (
    <>
      Please try again in some time or if you have any prior questions please
      write to us at <a href={`mailto:${email}`}>{email}</a>
    </>
  );
  const handleClick = () => {
    commonMsgPopupState.setShowMsgPopup(false);
  };

  if (success)
    commonMsgPopupState.setPopupValues({
      title: 'Awesome! Help is on the way.',
      description,
      customParentClassName: 'credit-upgrade-popup',
      actionBtnCallback: handleClick,
      clickOutsidePopupCallback: handleClick,
      closeClickCallback: handleClick,
    });
  else
    commonMsgPopupState.setPopupValues({
      title: 'Oops! Something went wrong!',
      description: descriptionError,
      customParentClassName: 'credit-upgrade-popup',
      actionBtnCallback: handleClick,
      clickOutsidePopupCallback: handleClick,
      closeClickCallback: handleClick,
    });
  commonMsgPopupState.setShowMsgPopup(true);
};

Utils.getActiveSubscriptioId = () => {
  const { userInfo } = userDetail;
  const { memberSubscription = null } = userInfo;

  if (memberSubscription) {
    const { id } = memberSubscription;
    return id;
  }
  return null;
};

Utils.checkIsPersonalisedOnboardingAllowedPath = () => {
  const { pathname = '' } = window.location;
  const partialHeaderUrls = [
    '/advanced-search/contact',
    '/advanced-search/company',
  ];
  const matchingUrls = partialHeaderUrls.filter(item =>
    pathname.includes(item),
  );
  return matchingUrls.length > 0;
};

Utils.checkShowPersonalisedOnboarding = () => {
  if (
    Utils.isFreeTrialPlan() &&
    !Utils.isEnterpriseFreeTrialPlan() &&
    Utils.checkIsPersonalisedOnboardingAllowedPath()
  )
    return true;
  return false;
};

Utils.getUserName = () => {
  const { userInfo } = userDetail;
  const { email = '', name = '' } = userInfo;

  const nameStr =
    name || (email && email.includes('@') ? email.split('@')[0] : '');
  return nameStr;
};

Utils.personalisedOnboardingEventMap = (currentStep = '') => {
  const {
    PERSONALIED_ONBOARDING_FLOWS,
    MX_PERSONALISED_ONBOARDING_EVENTS,
  } = CONSTANTS;
  const {
    EMAIL_CAMPAIGN_LIST,
    TARGETED_ACCOUNTS,
    AD_AUDIENCE_LIST,
    SINGLE_CONTACT_ONLY,
  } = PERSONALIED_ONBOARDING_FLOWS;
  const {
    LB_GOAL_AD_AUDIENCE,
    LB_GOAL_EMAIL_CAMPAIGN,
    LB_GOAL_SINGLE_CONTACT,
    LB_GOAL_TARGET_ACCOUNTS,
  } = MX_PERSONALISED_ONBOARDING_EVENTS;
  let mxEventName = null;

  if (currentStep === SINGLE_CONTACT_ONLY) mxEventName = LB_GOAL_SINGLE_CONTACT;
  else if (currentStep === EMAIL_CAMPAIGN_LIST)
    mxEventName = LB_GOAL_EMAIL_CAMPAIGN;
  else if (currentStep === TARGETED_ACCOUNTS)
    mxEventName = LB_GOAL_TARGET_ACCOUNTS;
  else if (currentStep === AD_AUDIENCE_LIST) mxEventName = LB_GOAL_AD_AUDIENCE;

  return mxEventName;
};

Utils.openNewTab = url => {
  window.open(url, '_blank');
};

Utils.checkIsRefinerAllowed = () => {
  if (
    Utils.isFreeTrialPlan() &&
    !Utils.isEnterpriseFreeTrialPlan() &&
    Utils.isProductionEnv()
  )
    return true;
  return false;
};

Utils.setRefinerProject = () => {
  if (Utils.checkIsRefinerAllowed())
    _refiner('setProject', '1a9cf9a0-9de2-11ec-b9cd-e953878f83f2');
};

Utils.registerRefiner = (property = {}) => {
  const { userInfo } = userDetail;
  const { name, email, pageSource } = userInfo;
  const { trialEndDays } = trialUserOnboardingState;
  const {
    LB_REF_PROPERTY_USER_PAGE_SOURCE,
    LB_REF_PROPERTY_NO_OF_DAYS_LEFT_IN_TRIAL,
  } = REFINER_EVENTS_AND_PROPERTIES;

  const data = {
    id: email,
    email,
    name,
    [LB_REF_PROPERTY_USER_PAGE_SOURCE]: pageSource,
    [LB_REF_PROPERTY_NO_OF_DAYS_LEFT_IN_TRIAL]: trialEndDays,
    ...property,
  };

  try {
    _refiner('identifyUser', data);
  } catch (e) {
    console.error('_refiner not defined ', e);
  }
};

Utils.trackRefinerProperty = (property = {}) => {
  if (property) Utils.registerRefiner(property);
};

Utils.addRemainingCreditsToRefinerProperty = data => {
  const { userInfo } = userDetail;
  const { lbCredits, lbCreditsPlan } = userInfo;
  const newObj = data || {};
  const { LB_REF_PROPERTY_CREDITS_REMAINING } = REFINER_EVENTS_AND_PROPERTIES;
  if (lbCreditsPlan) newObj[LB_REF_PROPERTY_CREDITS_REMAINING] = lbCredits;
  return newObj;
};

Utils.trackRefinerSearchPerformedCount = () => {
  if (Utils.checkIsRefinerAllowed()) {
    const { LB_REF_PROPERTY_SEARCH_PERFORMED } = REFINER_EVENTS_AND_PROPERTIES;
    let searchPerformedCount = Utils.getCookie('searchPerformed');

    if (searchPerformedCount) {
      searchPerformedCount = parseInt(searchPerformedCount, 10);
      searchPerformedCount += 1;
    } else {
      searchPerformedCount = 1;
    }
    Utils.setCookie('searchPerformed', searchPerformedCount);
    let data = {
      [LB_REF_PROPERTY_SEARCH_PERFORMED]: searchPerformedCount,
    };
    data = Utils.addRemainingCreditsToRefinerProperty(data);
    Utils.trackRefinerProperty(data);
  }
};

Utils.trackRefinerContactOrCompanyFilterApplied = (
  appliedFilterData = {},
  searchCount,
) => {
  if (Utils.checkIsRefinerAllowed()) {
    const { companyName = [], name = [] } = appliedFilterData;
    if ((companyName && companyName.length > 0) || (name && name.length > 0)) {
      const {
        LB_REF_PROPERTY_CONTACT_OR_COMPANY_NAME_FILTER_APPLIED,
        LB_REF_PROPERTY_SEARCH_RESULT_COUNT,
      } = REFINER_EVENTS_AND_PROPERTIES;
      Utils.trackRefinerProperty({
        [LB_REF_PROPERTY_CONTACT_OR_COMPANY_NAME_FILTER_APPLIED]: true,
        [LB_REF_PROPERTY_SEARCH_RESULT_COUNT]: searchCount,
      });
    }
  }
};

Utils.trackRefinerPricingPageViewed = () => {
  if (Utils.checkIsRefinerAllowed()) {
    const { LB_REF_PROPERTY_PRICING_VISITED } = REFINER_EVENTS_AND_PROPERTIES;
    let data = {
      [LB_REF_PROPERTY_PRICING_VISITED]: true,
    };
    data = Utils.addRemainingCreditsToRefinerProperty(data);
    Utils.trackRefinerProperty(data);
  }
};

Utils.trackRefinerRemainingCredits = () => {
  if (Utils.checkIsRefinerAllowed()) {
    const data = Utils.addRemainingCreditsToRefinerProperty({});

    setTimeout(() => {
      Utils.trackRefinerProperty(data);
    }, 2000);
  }
};

Utils.checkIsCSVExportEnabled = exportSource => {
  const { featureFlags } = userDetail;
  const { CSV_EXPORT = false, LEAD_BUILDER = false } = featureFlags || {};
  const { ADVANCED_SEARCH } = EXPORT_SOURCE;
  const isCsvEnabled =
    (exportSource === ADVANCED_SEARCH && LEAD_BUILDER && CSV_EXPORT) ||
    (exportSource !== ADVANCED_SEARCH && CSV_EXPORT);
  return isCsvEnabled;
};

Utils.checkIsCRMExportEnabled = exportSource => {
  const { featureFlags } = userDetail;
  const { CRM_EXPORT = false, LEAD_BUILDER = false } = featureFlags || {};
  const { ADVANCED_SEARCH } = EXPORT_SOURCE;
  const isCrmEnabled =
    (exportSource === ADVANCED_SEARCH && LEAD_BUILDER && CRM_EXPORT) ||
    (exportSource !== ADVANCED_SEARCH && CRM_EXPORT);
  return isCrmEnabled;
};

Utils.checkIsLeadBuilderEnabled = () => {
  const { featureFlags } = userDetail;
  const { LEAD_BUILDER = false } = featureFlags || {};
  return LEAD_BUILDER;
};

Utils.checkIsPaginationEnabled = () => {
  const { featureFlags } = userDetail;
  const { SEARCH_RESULTS = false } = featureFlags || {};
  return SEARCH_RESULTS;
};

Utils.isStarterPlanActive = () => {
  const { currentSubscriptionPlanInfo } = userDetail;
  const { name = '' } = currentSubscriptionPlanInfo || {};
  return name === 'STARTER';
};

Utils.getFormattedDate = (dateNumber, showRecentText = false) => {
  if (dateNumber) {
    const date = format(new Date(dateNumber), 'MMM dd, yyyy');
    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    const currentDate = new Date();
    let modifiedDate = date;
    if (showRecentText)
      if (date === format(currentDate, 'MMM dd, yyyy')) modifiedDate = 'Today';
      else if (date === format(yesterday, 'MMM dd, yyyy'))
        modifiedDate = 'Yesterday';
    return modifiedDate;
  }
  return '';
};

Utils.getSupportEmail = () => {
  if (Utils.isLBPaidSubscription()) return 'success@adapt.io';
  if (Utils.isLBPaidUser()) return 'sales@adapt.io';
  return 'support@adapt.io';
};

Utils.isSharedList = (listType = '') => {
  return listType === 'shared';
};

Utils.isSharedListEnabled = () => {
  return Utils.getUserType() !== 'FREE';
};

export { Utils };
export default Utils;
